import React from "react"
import { motion } from "framer-motion"

type Props = {
  cx: number
  cy: number
  activeSection: boolean
}

const ActiveCircles: React.FC<Props> = ({
  cx,
  cy,
  activeSection,
}): JSX.Element => {
  return (
    <g className={`smallCircles ${activeSection ? "active" : ""}`}>
      <motion.circle
        // stroke={"#df4a32"}
        strokeWidth={2}
        fill={"#df4a32"}
        strokeLinecap="round"
        strokeLinejoin="round"
        transition={{ duration: 1, ease: "easeOut" }}
        r={11}
        style={{ opacity: 0.4 }}
        cx={cx}
        cy={cy}
        // transform={`translate(-2 0)`}
      ></motion.circle>
      <motion.circle
        stroke={"#707070"}
        strokeWidth={2}
        fill={"transparent"}
        strokeLinecap="round"
        strokeLinejoin="round"
        r={18}
        transition={{
          cx: { duration: 1, ease: "easeOut" },
          cy: { duration: 1, ease: "easeOut" },
          scale: { duration: 4, yoyo: Infinity },
          opacity: { duration: 4, yoyo: Infinity },
        }}
        cx={cx}
        cy={cy}
        initial={{
          opacity: 0.2,
          scale: 1,
        }}
        animate={{
          opacity: 0.4,
          scale: 1.1,
        }}
        // transform={`translate(-2 -0)`}
      ></motion.circle>
      <motion.circle
        stroke={"#707070"}
        strokeWidth={2}
        fill={"transparent"}
        strokeLinecap="round"
        strokeLinejoin="round"
        // style={{ opacity: 0.1 }}
        r={25}
        transition={{
          cx: { duration: 1, ease: "easeOut" },
          cy: { duration: 1, ease: "easeOut" },
          scale: { duration: 4, yoyo: Infinity },
          opacity: { duration: 4, yoyo: Infinity },
        }}
        cx={cx}
        cy={cy}
        initial={{
          opacity: 0.1,
          scale: 1,
        }}
        animate={{
          opacity: 0.2,
          scale: 1.1,
        }}

        // transform={`translate(-2 0)`}
      ></motion.circle>
    </g>
  )
}

export default ActiveCircles
